module.exports = __webpack_public_path__ + "img/banner_icon1.9bb30995.svg";